import Grid from "../Utils/Grid.styled";
import Card from "../Card";
import useNavigateParams from "../../helper/navigateHelper";
import Stack from "../Utils/Stack.styled";
import PropTypes from "prop-types";

const VideoGrid = ({
  param,
  onSelectedVideoId,
  videoList,
  grid,
  currentSelectedVideoId,
}) => {
  const navigate = useNavigateParams();

  const onChangeScreen = (videoId, title, image) => {
    navigate(`${videoId}`, { q: param });
    window.scrollTo(0, 0);
    onSelectedVideoId(videoId, title, image);
  };

  const renderCard = (video, i) => {
    return (
      <Card
        id={video.id.videoId}
        key={video.id.videoId}
        image={video.snippet.thumbnails.url}
        title={video.title}
        duration={video.duration_raw}
        views={video.views}
        channel={video.channelName}
        onClick={() => {
          onChangeScreen(
            video.id.videoId,
            video.title,
            video.snippet.thumbnails.url
          );
        }}
        grid={grid}
      />
    );
  };
  return grid ? (
    <Grid>{videoList && videoList.data.map((it, i) => renderCard(it, i))}</Grid>
  ) : (
    <Stack direction="column" gap="16">
      {videoList &&
        videoList.data
          .filter((video) => video.id.videoId !== currentSelectedVideoId)
          .map((it, i) => renderCard(it, i))}
    </Stack>
  );
};

VideoGrid.propTypes = {
  grid: PropTypes.number,
};

export default VideoGrid;
